import Professional from '@/services/Professional';
import Patient from '@/services/Patient';
import { errorLog } from '@/utils/logger';
import Conpass from '@/services/Conpass';

export default {
  setWorkspaces: ({ commit }, workspaces) =>
    commit('SET_WORKSPACES', workspaces),

  setCurrentWorkspace: ({ commit }, currIndex) =>
    commit('SET_CURRENT_WORKSPACE', currIndex),

  toggleSidebar: ({ commit }) => commit('TOGGLE_SIDEBAR'),

  toggleModal: ({ commit }, modalName) => commit('TOGGLE_MODAL', modalName),

  closeModals: ({ commit }) => commit('TOGGLE_MODAL', null),

  clearPatientSearchFilters: ({ commit }) => commit('CLEAR_PATIENT_SEARCH'),

  searchPatientByName: ({ commit }, patientName) => {
    Patient.searchByName(patientName).then(response => {
      commit('SEARCH_PATIENT', response.data.conteudo);
    });
  },

  toggleDuty: async ({ commit, state, dispatch }, onDuty) => {
    commit('SET_DUTY_LOADING', true);
    try {
      await Professional.toggleDuty(onDuty);
      commit('SET_DUTY', onDuty);
    } catch (err) {
      if (err?.response?.data.msg) {
        alert(err?.response.data.msg || 'Houve um erro ao alterar o plantão.');
      }
    }
    commit('SET_DUTY_LOADING', false);
  },

  fetchDuty: async ({ commit, state }) => {
    commit('SET_DUTY_LOADING', true);
    try {
      const isOnDuty = await Professional.fetchCurrDutyState();
      commit('SET_DUTY', isOnDuty);
    } catch (err) {
      errorLog(err);
    }
    commit('SET_DUTY_LOADING', false);
  },

  toggleWelcome: ({ commit, dispatch }) =>
    dispatch('toggleModal', 'newMedicWelcome'),

  provideOnboarding: ({ getters }) => {
    Conpass.init([getters.currFullName, getters.currWorkspace.email]);
  },
};
